import {
    LucideFlame,
    LucideHand,
    LucideLeaf,
    LucideSparkles,
    LucideZap,
} from "lucide-react";

export const HowToGuide = () => {
    return (
        <section id="instructies" className="py-24 bg-ink-900 border-t border-ink-800">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

                <div className="text-center mb-16">
                    <span className="inline-block text-sm font-semibold uppercase tracking-[0.2em] text-ember-400 mb-3">
                        In 5 stappen
                    </span>
                    <h2 className="font-display font-bold uppercase text-4xl lg:text-5xl text-ink-50">
                        Word vuurmeester
                    </h2>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6">
                    {howToStepsData.map((x) => (
                        <HowToStep
                            key={x.stepNumber}
                            title={x.title}
                            description={x.description}
                            icon={x.icon}
                            stepNumber={x.stepNumber}
                        />
                    ))}
                </div>
            </div>
        </section>
    );
};

interface howToStepsProps {
    stepNumber: number;
    title: string;
    description: string;
    icon: React.ComponentType<{ className?: string }>;
}

const howToStepsData: howToStepsProps[] = [
    {
        stepNumber: 1,
        title: "Verzamel",
        description: "Verzamel droog en ontvlambaar materiaal, denk aan zaagsel, katoen of droge bladeren en leg dit op een hoopje.",
        icon: LucideLeaf,
    },
    {
        stepNumber: 2,
        title: "Schraap",
        description: "Neem de kartelrand van de schraper en schraap magnesium van de staaf op het verzamelde materiaal.",
        icon: LucideHand,
    },
    {
        stepNumber: 3,
        title: "Strijk",
        description: "Neem de vlakke kant van de schraper en strijk de staaf tot er een vonk ontstaat die het hoopje laat ontvlammen.",
        icon: LucideSparkles,
    },
    {
        stepNumber: 4,
        title: "Ontvlam",
        description: "Gaat het vuur uit? Herhaal stap twee en drie tot het magnesium goed ontvlamt.",
        icon: LucideZap,
    },
    {
        stepNumber: 5,
        title: "Vuur!",
        description: "Eenmaal aangestoken maak je het vuur groter door extra materiaal zoals hout toe te voegen.",
        icon: LucideFlame,
    },
];

const HowToStep = (props: howToStepsProps) => {
    const Icon = props.icon;
    return (
        <div className="relative bg-ink-800 p-6 rounded-2xl border border-ink-700 hover:border-ember-500/50 transition-colors">
            <span className="absolute top-4 right-5 font-display text-5xl font-bold text-ink-700 select-none">
                {props.stepNumber}
            </span>

            <span className="relative flex h-12 w-12 items-center justify-center rounded-xl bg-fire-gradient shadow-ember-sm mb-5">
                <Icon className="h-6 w-6 text-white" />
            </span>

            <h4 className="font-display text-lg font-bold uppercase tracking-wide text-ink-50">
                {props.title}
            </h4>

            <p className="mt-2 text-ink-300 text-sm leading-relaxed">
                {props.description}
            </p>
        </div>
    );
};
